import { first, last } from '../../../../utils';

// Adds extension to file name
function addExtension(fileName, file) {
  var rootName = first(fileName.split('.'));
  var extension = last(file.name.split('.'));
  return "".concat(rootName, ".").concat(extension);
}
export default addExtension;